import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { ArrivePlanService } from '../../../service/arrive-plan/arrive-plan.service';
import { ClientReportService } from '../../../service/client-report/client-report.service';
import { LocaService } from '../../../service/loca/loca.service';
import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma, toInteger } from '../../../util/util';
import { isNumber } from '../../../util/util';
import { isAuthority } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { OwnerService } from '../../../service/owner/owner.service';
import { ArriveResultService } from '../../../service/arrive-result/arrive-result.service';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';

@Component({
  selector: 'app-root',
  templateUrl: 'wa1010.component.html',
  styleUrls: ['wa1010.component.scss']
})
export class Wa1010Component implements AfterViewInit, DoCheck {
  private gridApi: any;
  private ownerGridApi: any;
  private loginGridApi: any;
  public componentTitle = 'WA1010:入荷予定照会';
  public updprogramCd = 'WA1010';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;
  private isShowRemoveModal = false;
  private isEnableSendMailButton = false;

  public showButton = false;
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for print
  public reporttrnId: number;
  private reportOpened = false;
  private reportTry = 0;
  public url = '#';
  public disableF26 = isAuthority('wa1010', 'F26');

  public checkbox = 0;

  public Item: number = 0;
  public ItemNum: number = 0;
  public ItemA: number = 0;
  public ItemB: number = 0;
  public ItemC: number = 0;

  public Item_A: number;
  public Item_B: number;
  public Item_C: number;

  public aa: number;
  public over: boolean = true;
  public modalCon: number;
  public openotherwindow: boolean = false;
  public display: boolean = true;

  private gridHelper: AgGridHelper;
  private isFilterExcludeArriveCompleteChecked = false;
  private isEnableClearFilter = false;
  private errorMssage = '';
  private errorMssage2 = '';
  private errorMssageForLogin = '';

  private ownerGridOptions: GridOptions;
  private ownerRowData: any[];
  private ownerGridHelper: AgGridHelper;
  private isEnableOwnerClearFilter = false;
  private ownerGridHeight = 300;
  private paginationGetRowCount2 = 0;
  private selectedCount2 = 0;

  @ViewChild('gridView')
  gridView: ElementRef;

  @ViewChild('ownerGridView')
  ownerGridView: ElementRef;

  private isShow1014 = false;

  private originalRowData: any[];
  private overlaydspnone: boolean = true;

  private selectownerId;
  private selectownerTx;

  private selectedCount = 0;
  private paginationGetRowCount = 0;
  private isOnUnArrival = false;

  private isShowRemoveOverlay = false;
  private isShowSendLoading = false;

  private isOwnerLinked: boolean = false;

  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private loading: boolean = false;
  private filter: boolean = false;

  constructor(
    private router: Router,
    private arrivePlanService: ArrivePlanService,
    private locaService: LocaService,
    private clientReportService: ClientReportService,
    private pdfReportService: PdfReportService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private ownerService: OwnerService,
    private el: ElementRef,
    private arriveResultService: ArriveResultService
  ) {
    const loginResult = sessionStorage.getItem('loginResult');
    console.log('ngAfterViewInit.verifyLogin: ', loginResult);
    let user;
    if (loginResult !== null) {
      const resultObject = JSON.parse(loginResult);
      user = resultObject.user;
      if (user.roleId <= 1) this.showButton = true;
      this.isOwnerLinked = user.roleId == 3 ? true : false;
    }

    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      pagination: true,
      onColumnResized: params => {
        this.saveColumnWidth(params);
      },
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa1010_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        // this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
      },
      onFilterChanged: () => {
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        /*
        if (this.InputOwnerchange == true) {
          this.gridHelper.deleteFilterOverlay();
        }
        else {
          this.gridHelper.onGridFilterChanged();
        }
        */
        this.gridHelper.onGridFilterChanged();

        this.errorMssage = '';
        this.filter = true;
      },
      getRowClass: params => {
        if (params.data['starriveplanTx'] === '入荷完了') return 'status3_rowstyle';
        return null;
      },
      onRowDataChanged: () => {
        //this.filterGridByArrivePlan();
        this.selectedCount = 0;
        this.gridHelper.onRowDataChanged();
        this.errorMssage = '';
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorMssage = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorMssage = '';
      },
      onSelectionChanged: () => {
        this.selectedCount = this.gridOptions.api.getSelectedRows() == null ? 0 : this.gridOptions.api.getSelectedRows().length;
        this.errorMssage = '';
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
        // if (this.paginationGetRowCount < 0) {
        //   overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA;
        // }
      }
    };
    this.gridHelper.setGridOptions(this.gridOptions);
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'colCheck',
        width: 30,
        cellClass: ['tc', 'noCellFocus'],
        checkboxSelection: true,
        pinned: 'left',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        suppressSorting: true,
        suppressFilter: true
      },
      {
        headerName: '',
        field: 'col1Scroll',
        suppressMenu: true,
        width: 8,
        cellClass: ['tc', 'cellclass'],
        hide: true,
        pinned: 'left',
        cellStyle: function (params) {
          //ステータス色変化
          if (params.data.starriveplanTx == '未入荷') {
            return { backgroundColor: 'rgba(235,153,175,0.2)', color: '#eb99af' };
          } else if (params.data.starriveplanTx == '入荷受付中') {
            return { backgroundColor: 'rgba(227,230,87,0.2)', color: 'rgba(227,230,87,0.2)' };
          } else if (params.data.starriveplanTx == '入荷完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '入荷予定ID',
        field: 'arriveplanId',
        sort: 'desc',
        width: this.getColumnWidth('arriveplanId', 100),
        cellClass: ['tr', 'cellclass'],
        suppressMenu: true,
        unSortIcon: true
      },
      {
        headerName: '入荷ステータス',
        field: 'starriveplanTx',
        width: this.getColumnWidth('starriveplanTx', 150),
        suppressMenu: true,
        cellClass: ['tc', 'cellclass'],
        cellStyle: function (params) {
          //ステータス色変化
          if (params.value == '未入荷') {
            return { backgroundColor: 'rgba(235,153,175,0.2)' };
          } else if (params.value == '入荷受付中') {
            return { backgroundColor: 'rgba(227,230,87,0.2)' };
          } else if (params.value == '入荷完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: '#b3b2b2' };
          } else {
            return null;
          }
        },
        unSortIcon: true
      },
      {
        headerName: '入荷予定日',
        field: 'arriveplanDt',
        width: this.getColumnWidth('arriveplanDt', 100),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '注文No',
        field: 'arriveordernoCd',
        width: this.getColumnWidth('arriveordernoCd', 80),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '注文No行番号',
        field: 'arriveorderdetnoCd',
        width: this.getColumnWidth('arriveorderdetnoCd', 80),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        suppressMenu: true,
        cellClass: ['tc', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 300),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 150),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 300),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '入荷番号',
        field: 'arrivenoCd',
        width: this.getColumnWidth('arrivenoCd', 150),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 80),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 80),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 80),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '入数',
        field: 'amountNr',
        width: this.getColumnWidth('amountNr', 80),
        suppressMenu: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
        unSortIcon: true
      },
      {
        headerName: '入荷予定数',
        field: 'arriveplanNr',
        width: this.getColumnWidth('arriveplanNr', 100),
        suppressMenu: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
        unSortIcon: true
      },
      {
        headerName: '入荷予定残数',
        field: 'arriveleftNr',
        width: this.getColumnWidth('arriveleftNr', 100),
        valueFormatter: insertcomma,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '仕入れ先',
        field: 'supplierTx',
        width: this.getColumnWidth('supplierTx', 100),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 200),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 200),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        unSortIcon: true
      }
    ];

    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin - 34;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.initOwnerGrid();
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa1010_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa1010_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa1010_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    this.ownerGridHelper.el = this.ownerGridView;
    setTimeout(() => {
      this.onSubmit(1);
    }, config.waitMsForSearchInNgAfterViewInit);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin - 34;
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit(1);
    } else {
      this.ownerId = null;
      this.rowData = [];
      this.originalRowData = [];
      this.gridOptions.api.deselectAll();
      this.filterGridByArrivePlan();
    }
  }

  onFilterClear() {
    this.errorMssage = '';
    this.gridOptions.api.setFilterModel(null);
    // this.filterGridByArrivePlan();
  }

  onSubmit(showAll?) {
    this.errorMssage = '';
    if (this.ownerId == null && this.ownerId !== undefined) {
      this.originalRowData = [];
      this.gridOptions.api.deselectAll();
      this.filterGridByArrivePlan();
      this.ItemNum = 0;
      this.ItemA = 0;
      this.ItemB = 0;
      this.ItemC = 0;
      return;
    }
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    // アクティブタブ設定
    // アクティブなタブが未入荷
    if (this.Item === 0) {
      showAll = 1;
    // アクティブなタブが受付中
    } else if (this.Item === 1) {
      showAll = 2;
    // アクティブなタブが入荷完了
    } else if (this.Item === 2) {
      showAll = 3;
    // アクティブなタブがすべて、かつ入荷完了以外にチェックがない
    } else if (this.Item === 3 && !this.isFilterExcludeArriveCompleteChecked) {
      showAll = 4;
    // アクティブなタブがすべて、かつ入荷完了以外にチェックがある
    } else if (this.Item === 3 && this.isFilterExcludeArriveCompleteChecked) {
      showAll = 0;
    }
    this.arrivePlanService
      .get(this.ownerId, showAll)
      .then(outputJson => {
        console.log(outputJson);
        this.originalRowData = outputJson.arriveplans;
        this.gridOptions.api.deselectAll();
        this.filterGridByArrivePlan();
        this.ItemNum = outputJson.arriveplans.length;
        
        this.ItemA = 0;
        for (let i = 0; i < this.ItemNum; i++) {
          if (this.originalRowData[i].starriveplanTx === '入荷受付中') {
            this.ItemA++;
          }
        }
        this.ItemB = 0;
        for (let i = 0; i < this.ItemNum; i++) {
          if (this.originalRowData[i].starriveplanTx === '未入荷') {
            this.ItemB++;
          }
        }
        this.ItemC = 0;
        for (let i = 0; i < this.ItemNum; i++) {
          if (this.originalRowData[i].starriveplanTx === '入荷完了') {
            this.ItemC++;
          }
        }

        if (this.ItemNum > 0) {
          this.Item_A = (this.ItemA / this.ItemNum) * 100;
          this.Item_B = (this.ItemB / this.ItemNum) * 100;
          this.Item_C = (this.ItemC / this.ItemNum) * 100;
        } else {
          this.Item_A = 0;
          this.Item_B = 0;
          this.Item_C = 0;
        }

        // SWMS-3022 入荷予定照会にて、初期表示時、検索結果が100件までしか表示されない。
        if (this.Item === 0) {
          this.gridOptions.api.paginationSetPageSize(this.ItemB);
        }

        setTimeout(() => {
          this.isShowSendLoading = false;
          this.working = false;
        },300);
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorMssage = this.commonService.getErrorMessage(error);
      });
  }

  del() {

    this.errorMssage = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorMssage = '';
      this.errorMssage = '対象を選択して下さい';
    } else {
      //SW-2097　ダブルクリック抑止
      if (this.working) return;
      this.working = true;
      const selectedIndex: number[] = [];
      for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
        // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
        var data = this.gridOptions.api.getSelectedNodes()[i].data;
        selectedIndex.push(data['arriveplanId']);
      }
      console.log(selectedIndex);
      this.isShowSendLoading = true;
      this.arrivePlanService
        .delete(selectedIndex)
        .then(outputJson => {
          this.isShowSendLoading = false;
          this.working = false;
          this.onSubmit();
          this.isShowRemoveOverlay = false;
          sessionStorage.setItem('SuccessInfoMessage', '削除が完了しました。');
        })
        .catch(error => {
          this.isShowSendLoading = false;
          console.log(this.commonService.getErrorMessage(error));
          this.errorMssage = this.commonService.getErrorMessage(error);
          this.isShowRemoveOverlay = false;
          this.working = false;
        });
    }
  }

  printKanban() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    this.errorMssage = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorMssage = '対象を選択して下さい';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    }
    // Change the flag of working to true in order to disable the submit button
    const selectIds: object[] = [];
    var selectedCount = this.gridOptions.api.getSelectedNodes().length;
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      var data = this.gridOptions.api.getSelectedNodes()[i].data;
      const jsonUnit: object = {
        selectId: data['arriveplanId']
      };
      selectIds.push(jsonUnit);
    }
    console.log(selectIds);
    // Reset the flag to indicate that the report has not been opened yet
    this.reportOpened = false;
    // Reset the limit counter
    this.reportTry = 0;
    // Submit the request to generate the report
    this.pdfReportService
      .post(0, 'TA_ARRIVEPLAN', 'RA9001', 0, 'wa1010', selectIds)
      .then(outputJson => {
        this.reporttrnId = outputJson.reporttrnId;
		// Call the PDF report service
        this.pdfReportService
          .printReport('RA9001', this.reporttrnId)
          .then(outputJson => {
              // Change the working flag to false in order to enable the submit button
              this.working = false;
			  this.isShowSendLoading = false;
              const url = environment.pdfPath + outputJson.pdfFilename;
              this.openReport(url);
            })
          .catch(error => {
             // Change the working flag to false in order to enable the submit button
             this.working = false;
			 this.isShowSendLoading = false;
             console.log(this.commonService.getErrorMessage(error));
             this.errorMssage = this.commonService.getErrorMessage(error);
          });
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorMssage = this.commonService.getErrorMessage(error);
      });
  }

  waitResult() {
    const obs = Observable.interval(1000).subscribe(() => {
      // Verify that we have not tried more than 10 times
      if (this.reportTry <= 10) {
        // Add a new try to the counter
        this.reportTry++;
        // Call the PDF report service
        this.pdfReportService
          .get(this.reporttrnId)
          .then(outputJson => {
            // seems we can get the report path correctly
            // If the createdFl is 0 the report has not finished so we retry again.
            // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
            if (outputJson.reports[0].createdFl === 1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              // Change the working flag to false in order to enable the submit button
              this.isShowSendLoading = false;
              const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
              // We open a new tab to display the PDF.
              // If preferred we could get the PDF data and send the blob to the new tab instead.
              this.openReport(url);
            }
            if (outputJson.reports[0].createdFl === -1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              this.isShowSendLoading = false;
              this.errorMssage = '対象データがないため帳票が作成できませんでした';
            }
          })
          .catch(error => {
            // Cancel the Observable in case of error
            obs.unsubscribe();
            // Change the working flag to false in order to enable the submit button
            this.isShowSendLoading = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorMssage = this.commonService.getErrorMessage(error);
          });
      } else {
        // Cancel the Observable if the number of tries maxed out
        obs.unsubscribe();
        // Change the working flag to false in order to enable the submit button
        this.isShowSendLoading = false;
        this.errorMssage = '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください';
      }
    });
  }

  // Open the newly generated report on a different tab/window
  openReport(url) {
    this.errorMssage = '';
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      this.url = url;
      this.isShowRemoveModal = true;
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
  }

  confirmOk() {
    const popup_window = window.open(this.url);
    try {
      popup_window.focus();
    } catch (e) {
      this.isShowRemoveModal = false;
    }
  }

  // 商品ラベル出力
  printItemLabel() {
    this.errorMssage = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.isShowSendLoading = false;
      this.errorMssage = '対象を選択して下さい';
      return;
    }
    this.isShowSendLoading = true;
    const selectIds: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      var data = this.gridOptions.api.getSelectedNodes()[i].data;
      // push data
      const jsonUnit: object = {
        selectId: data['arriveplanId']
      };
      selectIds.push(jsonUnit);
    }
    sessionStorage.setItem('wa1010-arriveplanId-itemLabel', JSON.stringify(selectIds));
    this.isShowSendLoading = false;
    this.router.navigate(['wa1013']);
  }

  // クライアント帳票出力
  printClientReport(reportCd: string) {
    this.errorMssage = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.isShowSendLoading = false;
      this.errorMssage = '対象を選択して下さい';
      return;
    }
    this.isShowSendLoading = true;
    switch (reportCd) {
      case 'RA1003':
        break;
      default:
        this.isShowSendLoading = false;
        this.errorMssage = '予期せぬエラー：未定義の帳票コードです';
        return;
    }
    let ownerId = 0;
    const selectIds: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      var data = this.gridOptions.api.getSelectedNodes()[i].data;
      // push data
      const jsonUnit: object = {
        selectId: data['arriveplanId']
      };
      selectIds.push(jsonUnit);
    }
    this.clientReportService
      .post(ownerId, reportCd, '', this.updprogramCd, selectIds)
      .then(outputJson => {
        this.isShowSendLoading = false;
      })
      .catch(error => {
        this.isShowSendLoading = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorMssage = this.commonService.getErrorMessage(error);
      });
  }

  sendResult() {
    this.router.navigate(['wa1012']);
  }

  showAll() {
    this.onSubmit(this.checkbox ? 1 : 0);
  }

  createResult() {
    this.errorMssage = '';
    this.isShowSendLoading = true;
    if (!this.ownerId) {
      this.isShowSendLoading = false;

      this.errorMssage = '荷主を選択して下さい';
      return false;
    }
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.isShowSendLoading = false;

      this.errorMssage = '対象を選択して下さい';
      return false;
    } else if (this.gridOptions.api.getSelectedNodes().length > 10) {
      this.isShowSendLoading = false;
      this.errorMssage = '10行以内で選択して下さい';
      return false;
    }
    var selectedCount = this.gridOptions.api.getSelectedNodes().length;
    let selectItem = this.gridOptions.api.getSelectedNodes();
    let selectItemObj: object[] = [];
    for (let i = 0; i < selectItem.length; i++) {
      if (selectItem[i].data['starriveplanId'] == 4) {
        this.isShowSendLoading = false;

        this.errorMssage = '入荷完了データは選択出来ません。「入荷予定ID＝' + selectItem[i].data['arriveplanId'] + '」';
        return false;
      }
      selectItemObj.push(selectItem[i].data);
    }

    sessionStorage.setItem('selectItemObj', JSON.stringify(selectItemObj));
    this.isShowSendLoading = false;
    return true;
  }

  Tody: Date = new Date();
  onclick(type) {
    this.Item = type;
    this.isFilterExcludeArriveCompleteChecked = false;
    this.gridOptions.api.deselectAll();
    this.filter = false;
    if (type === 0) this.gridOptions.api.paginationSetPageSize(this.ItemB);
    else if (type === 1) this.gridOptions.api.paginationSetPageSize(this.ItemA);
    else this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    this.onSubmit(1);
  }

  overlay() {
    this.errorMssage = '';

    var ownerResult = sessionStorage.getItem('ownerResult');
    if (ownerResult != null)
      this.ownerId = JSON.parse(ownerResult).ownerId;
    else
      this.ownerId = undefined;
    if (this.ownerId === undefined) {
      this.over = false;
      this.renderOwnerGrid();
    } else {
      this.overlaydspnone = false;
      this.selectownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
      this.selectownerTx = JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx;
    }
  }

  closeOn() {
    this.over = true;
  }

  overlayclose() {
    this.overlaydspnone = true;
    this.errorMssage2 = '';
  }

  overlayClass() {
    let Classes = {
      overlay: true,
      dspnone: this.over
    };
    return Classes;
  }

  OpenBtn() {
    this.openotherwindow = true;
    this.display = false;
  }

  CloseBtn() {
    this.openotherwindow = false;
    this.display = true;
  }

  OpenClass() {
    let Display = {
      otherwindow: true,
      openotherwindow: this.openotherwindow,
      dspnone: !this.openotherwindow //this.display
    };
    return Display;
  }

  /**
   * Filter grid by arrive-plan-tx
   */
  filterGridByArrivePlan() {
    var filterKeys = [];
    switch (this.Item) {
      case 0:
        filterKeys.push('未入荷');
        break;
      case 1:
        filterKeys.push('入荷受付中');
        break;
      case 2:
        filterKeys.push('入荷完了');
        break;
      default: {
        if (this.isFilterExcludeArriveCompleteChecked) {
          filterKeys.push('未入荷');
          filterKeys.push('入荷受付中');
        }
      }
    }
    var bkgFilter = this.gridOptions.api.getFilterModel();
    this.gridOptions.api.setRowData([]);
    this.gridOptions.api.setFilterModel(bkgFilter);

    if (this.originalRowData == null || this.originalRowData.length == 0) {
      this.onRowDataChanged();
      return;
    }

    var newRowDatas = [];
    this.originalRowData.forEach(data => {
      if (filterKeys.length == 0 || filterKeys.indexOf(data.starriveplanTx) != -1) {
        newRowDatas.push(data);
      }
    });
    this.gridOptions.api.updateRowData({
      add: newRowDatas
    });
    this.onRowDataChanged();
  }

  onRowDataChanged() {
    this.gridHelper.onRowDataChanged();
    this.errorMssage = '';

    // let rowCount = this.gridOptions.api.getModel().getRowCount();
    // if (rowCount > 0) this.gridHelper.deleteFilterOverlay();
    // else this.gridHelper.insertNoDataFilterOverlay();
    //this.isShowGridNoDataOverlay = false;
    //else this.isShowGridNoDataOverlay = true;
  }

  /** Start Ownder Grid */
  initOwnerGrid() {
    this.ownerGridHelper = new AgGridHelper();
    // this.ownerGridHelper.gridSelectionCheckboxStyle = 'radio';
    this.ownerGridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      pagination: true,
      suppressRowClickSelection: false,
      onColumnResized: params => {
        this.saveColumnWidthOwner(params);
      },
      onColumnMoved: () => {
        this.saveColumnOrderOwner();
      },
      onGridReady: params => {
        this.ownerGridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa1010_OWNER_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }

        this.ownerGridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.isEnableOwnerClearFilter = this.ownerGridOptions.api.isAnyFilterPresent();
        this.ownerGridHelper.onGridFilterChanged();
        this.errorMssage2 = '';
      },

      onRowDataChanged: () => {
        this.ownerGridHelper.onRowDataChanged();
        this.errorMssage2 = '';
        this.isEnableSendMailButton = false;
      },
      overlayLoadingTemplate: this.ownerGridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.ownerGridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.ownerGridHelper.fixedAgMenu();
        this.errorMssage2 = '';
      },
      onSortChanged: () => {
        this.ownerGridHelper.renderGridCheckboxImage();
        this.errorMssage2 = '';
      },
      onSelectionChanged: () => {
        this.errorMssage2 = '';
        this.isEnableSendMailButton = this.ownerGridOptions.api.getSelectedRows().length > 0;
        this.selectedCount2 = this.ownerGridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount2 = this.ownerGridOptions.api.paginationGetRowCount();
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.ownerGridHelper.setGridOptions(this.ownerGridOptions);
    this.ownerGridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: true,
        cellClass: ['tc', 'noCellFocus']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getOwnerColumnWidth('ownerCd', 100),
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getOwnerColumnWidth('ownerTx', 610),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
  }
  getOwnerColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa1010_OWNER_${id}_width`), 10) || def;
  }

  saveColumnWidthOwner(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa1010_OWNER_${params.column.colId}_width`, params.column.actualWidth);
    }
  }
  saveColumnOrderOwner() {
    let idx = 0;
    for (const column of this.ownerGridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa1010_OWNER_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  renderOwnerGrid() {
    this.errorMssage2 = '';
    this.requestOwners();
  }

  requestOwners() {
    this.onOwnerFilterClear();
    this.errorMssage2 = '';
    this.selectedCount2 = 0;
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.ownerRowData = outputJson.owners;
        this.ownerGridHeight = this.ownerGridHelper.getElementHeight(this.el.nativeElement.querySelector('.modal-content__tablearea'));
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorMssage2 = this.commonService.getErrorMessage(error);
      });
  }

  onOwnerFilterClear() {
    this.ownerGridOptions.api.setFilterModel(null);
  }
  sendOwnerResult() {
    this.isShowSendLoading = true;
    if (this.ownerId === undefined) {
      this.over = true;
      this.errorMssage = '';
      if (this.ownerGridOptions.api.getSelectedNodes().length === 0) {
        this.errorMssage = '対象を選択して下さい';
        return;
      }
      const selectItems: object[] = [];
      for (let i = 0; i < this.ownerGridOptions.api.getSelectedNodes().length; i++) {
        // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
        var data = this.ownerGridOptions.api.getSelectedNodes()[i].data;
        const jsonUnit: object = {
          ownerId: data['ownerId']
        };
        selectItems.push(jsonUnit);
      }

      this.arriveResultService
        .sendResult(selectItems, this.updprogramCd)
        .then(outputJson => {
          this.isShowSendLoading = false;
          this.over = true;
          sessionStorage.setItem('SuccessInfoMessage', '入荷実績を送信しました。');
        })
        .catch(error => {
          this.over = true;
          this.isShowSendLoading = false;
          console.log(this.commonService.getErrorMessage(error));
          this.errorMssage = this.commonService.getErrorMessage(error);
        });
    } else {
      this.overlaydspnone = true;
      const selectItems: object[] = [];
      const jsonUnit: object = {
        ownerId: this.selectownerId
      };
      selectItems.push(jsonUnit);
      this.arriveResultService
        .sendResult(selectItems, this.updprogramCd)
        .then(outputJson => {
          this.isShowSendLoading = false;
          sessionStorage.setItem('SuccessInfoMessage', '入荷実績を送信しました。');
        })
        .catch(error => {
          this.isShowSendLoading = false;
          console.log(this.commonService.getErrorMessage(error));
          this.errorMssage = this.commonService.getErrorMessage(error);
        });
    }
  }
  /** END */

  /** Login grid start */
  openOtherWindow() {
    if (!this.createResult()) return;
    this.errorMssage = '';
    sessionStorage.setItem('wa1014_ownerId', this.ownerId + '');

    this.isOnUnArrival = this.Item == 0;
    this.isShow1014 = true;
    sessionStorage.setItem('isOwnerDisable', 'true');
  }
  /** END */

  onShow1014Change(isClose1014AndRefreshGrid: boolean) {
    sessionStorage.removeItem('isOwnerDisable');
    this.isShow1014 = false;
    if (isClose1014AndRefreshGrid) {
      this.onSubmit(1);
    }
  }

  showRemoveOverlay() {
    if (this.selectedCount == 0) return;
    this.errorMssage = '';
    this.isShowRemoveOverlay = true;
  }
  hideRemoveOverlay() {
    this.isShowRemoveOverlay = false;
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  ngDoCheck() {
    if (sessionStorage.getItem('SuccessInfoMessage') == '入荷実績を送信しました。') {
      this.loading = true;
    } else {
      this.loading = false;
    }
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1010/wa1010.component.ts